import {SecurityContext} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

/** Isolate email markup from navigation, scripts, forms and remote tracking images. */
export function emailPreviewHtml(sanitizer: DomSanitizer, html: string): SafeHtml {
  const clean = sanitizer.sanitize(SecurityContext.HTML, html) ?? '';
  const document = new DOMParser().parseFromString(clean, 'text/html');
  document.querySelectorAll('a').forEach(link => { link.removeAttribute('href'); link.removeAttribute('target'); });
  const policy = "default-src 'none'; style-src 'unsafe-inline'; img-src data:; form-action 'none'; base-uri 'none'";
  return sanitizer.bypassSecurityTrustHtml(`<html><head><meta http-equiv="Content-Security-Policy" content="${policy}"><meta name="referrer" content="no-referrer"></head><body>${document.body.innerHTML}</body></html>`);
}
